import React from "react";
import { FEATURES } from "./courseData";

const LanguageLandingFeatures = () => {
  return (
    <section id="ll-why" className="ll-section ll-why">
      <div className="container">
        <header className="section-header wow fadeInUp">
          <span className="ll-section-label">Why Koderbox</span>
          <h2 className="about_head">
            Everything You Need to{" "}
            <span className="highlighted-text">Master a New Language</span>
          </h2>
          <p className="ll-section-subtitle">
            We combine live instruction, small batches, and career support to
            help you succeed — not just pass an exam.
          </p>
        </header>

        <div className="ll-features-grid">
          {FEATURES.map((feature, index) => (
            <div
              key={feature.title}
              className="ll-feature-card wow fadeInUp"
              data-wow-delay={`${index * 0.1}s`}
            >
              <div className="ll-feature-card__icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LanguageLandingFeatures;
